//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import QRCode from "qrcode";
import { mapState } from "vuex";
// import Storage from "@/utils/storage";
import { generateOrder, queryOrderStatus, queryCoupon } from "@/api/newSupport";
import { Collapse, CollapseItem, Radio, Dialog, Message } from "apower-ui";
// import { loginByToken } from "@/api/account";
// import { getQueryValue } from "@/utils/index";
import { isMobile } from "@/utils/is";

Vue.prototype.$message = Message;
const LANG = document.documentElement.lang;
export default {
  name: "Price",
  componentName: "Price",
  components: {
    Collapse,
    CollapseItem,
    Radio,
    ApDialog: Dialog,
  },
  data() {
    return {
      activeItem: null,
      // callMe: false,
      payMCall: false,
      payCCall: false,
      monthlyAll: false,
      creditAll: false,
      totalM: this.$t("mesage.countM1"),
      totalC: this.$t("mesage.count1"),
      monthlyActiveId: "18180852_Q",
      creditActiveId: "18180862_Y",
      paddle_id: "781996",
      // paypal_id: "739788_L",
      enPrices: {
        //当前选中购买的套餐
        id: "18180862_Y",
        label: this.$t("mesage.user1"),
        price: this.$t("mesage.numCountM1"),
        total_price: this.$t("mesage.countM1"),
        paddle: "781996",
        // paypal: "739788_L",
        show: true,
      },
      monthlyPrices: [
        {
          id: "18180852_Q",
          label: this.$t("mesage.user1"),
          price: this.$t("mesage.numCountM1"),
          total_price: this.$t("mesage.countM1"),
          paddle: "781966",
          // paypal: "739788_L",
          // espaddle: "739790",
          // espaypal: "739790_L",
          show: true,
        },
        {
          id: "18180853_Q",
          label: this.$t("mesage.user2"),
          price: this.$t("mesage.numCountM2"),
          total_price: this.$t("mesage.countM2"),
          paddle: "781971",
          // paypal: "739789_L",
          // espaddle: "739791",
          // espaypal: "739791_L",
          show: true,
        },
        {
          id: "18180854_Q",
          label: this.$t("mesage.user3"),
          price: this.$t("mesage.numCountM3"),
          total_price: this.$t("mesage.countM3"),
          paddle: "781974",
          // paypal: "739838_L",
          // espaddle: "739792",
          // espaypal: "739792_L",
          show: true,
        },
        {
          id: "18180855_Q",
          label: this.$t("mesage.user4"),
          price: this.$t("mesage.numCountM4"),
          total_price: this.$t("mesage.countM4"),
          paddle: "781975",
          // paypal: "739839_L",
          // espaddle: "739793",
          // espaypal: "739793_L",
          show: true,
        },
        {
          id: "18180856_Q",
          label: this.$t("mesage.user5"),
          price: this.$t("mesage.numCountM5"),
          total_price: this.$t("mesage.countM5"),
          paddle: "781976",
          // paypal: "739840_L",
          // espaddle: "739794",
          // espaypal: "739794_L",
          show: true,
        },
        {
          id: "18180857_Q",
          label: this.$t("mesage.user6"),
          price: this.$t("mesage.numCountM6"),
          total_price: this.$t("mesage.countM6"),
          paddle: "781977",
          // paypal: "739841_L",
          // espaddle: "739795",
          // espaypal: "739795_L",
          show: false,
        },
        {
          id: "18180858_Q",
          label: this.$t("mesage.user7"),
          price: this.$t("mesage.numCountM7"),
          total_price: this.$t("mesage.countM7"),
          paddle: "781981",
          // paypal: "739842_L",
          // espaddle: "739796",
          // espaypal: "739796_L",
          show: false,
        },
        {
          id: "18180859_Q",
          label: this.$t("mesage.user8"),
          price: this.$t("mesage.numCountM8"),
          total_price: this.$t("mesage.countM8"),
          paddle: "781984",
          // paypal: "739843_L",
          // espaddle: "739797",
          // espaypal: "739797_L",
          show: false,
        },
        {
          id: "18180860_Q",
          label: this.$t("mesage.user9"),
          price: this.$t("mesage.numCountM9"),
          total_price: this.$t("mesage.countM9"),
          paddle: "781989",
          // paypal: "739844_L",
          // espaddle: "739798",
          // espaypal: "739798_L",
          show: false,
        },
        {
          id: "18180861_Q",
          label: this.$t("mesage.user10"),
          price: this.$t("mesage.numCountM10"),
          total_price: this.$t("mesage.countM10"),
          paddle: "781993",
          // paypal: "739845_L",
          // espaddle: "739799",
          // espaypal: "739799_L",
          show: false,
        },
      ],
      creditPrices: [
        {
          id: "18180862_Y",
          label: this.$t("mesage.user1"),
          price: this.$t("mesage.numCount1"),
          total_price: this.$t("mesage.count1"),
          paddle: "781996",
          // paypal: "738908_L",
          // espaddle: "739155",
          // espaypal: "739155_L",
          show: true,
        },
        {
          id: "18180863_Y",
          label: this.$t("mesage.user2"),
          price: this.$t("mesage.numCount2"),
          total_price: this.$t("mesage.count2"),
          paddle: "781998",
          // paypal: "738908_L",
          // espaddle: "739155",
          // espaypal: "739155_L",
          show: true,
        },
        {
          id: "18180864_Y",
          label: this.$t("mesage.user3"),
          price: this.$t("mesage.numCount3"),
          total_price: this.$t("mesage.count3"),
          paddle: "781999",
          // paypal: "738910_L",
          // espaddle: "739156",
          // espaypal: "739156_L",
          show: true,
        },
        {
          id: "18180865_Y",
          label: this.$t("mesage.user4"),
          price: this.$t("mesage.numCount4"),
          total_price: this.$t("mesage.count4"),
          paddle: "782001",
          // paypal: "738912_L",
          // espaddle: "739157",
          // espaypal: "739157_L",
          show: true,
        },
        {
          id: "18180866_Y",
          label: this.$t("mesage.user5"),
          price: this.$t("mesage.numCount5"),
          total_price: this.$t("mesage.count5"),
          paddle: "782004",
          // paypal: "738913_L",
          // espaddle: "739158",
          // espaypal: "739158_L",
          show: true,
        },
        {
          id: "18180867_Y",
          label: this.$t("mesage.user6"),
          price: this.$t("mesage.numCount6"),
          total_price: this.$t("mesage.count6"),
          paddle: "782005",
          // paypal: "738916_L",
          // espaddle: "739160",
          // espaypal: "739160_L",
          show: false,
        },
        {
          id: "18180868_Y",
          label: this.$t("mesage.user7"),
          price: this.$t("mesage.numCount7"),
          total_price: this.$t("mesage.count7"),
          paddle: "782008",
          // paypal: "738919_L",
          // espaddle: "739161",
          // espaypal: "739161_L",
          show: false,
        },
        {
          id: "18180869_Y",
          label: this.$t("mesage.user8"),
          price: this.$t("mesage.numCount8"),
          total_price: this.$t("mesage.count8"),
          paddle: "782010",
          // paypal: "738923_L",
          // espaddle: "739162",
          // espaypal: "739162_L",
          show: false,
        },
        {
          id: "18180870_Y",
          label: this.$t("mesage.user9"),
          price: this.$t("mesage.numCount9"),
          total_price: this.$t("mesage.count9"),
          paddle: "782011",
          // paypal: "738927_L",
          // espaddle: "739163",
          // espaypal: "739163_L",
          show: false,
        },
        {
          id: "18180871_Y",
          label: this.$t("mesage.user10"),
          price: this.$t("mesage.numCount10"),
          total_price: this.$t("mesage.count10"),
          paddle: "782014",
          // paypal: "738929_L",
          // espaddle: "739165",
          // espaypal: "739165_L",
          show: false,
        },
      ],
      qrcodeDialogVisible: false,
      qrCodeUrl: null, // 二维码
      isTimeout: false, // 二维码是否已过期
      isGeneratingOrder: false,
      invoice_amount: null,
      queryPayStatusTimeout: null, //
      timeoutInterval: null,
      timeoutCount: 1.5 * 60 * 60, // 订单过期时间两小时，设置过期时间一个半小时
      transaction: null,
      consumeDetail: null,
      content10: null,
      showCoupon: false, //优惠券
      currentActiveId: "", //当前弹窗的产品id
      couponLoading: false,
      showWeChat: false,
      showmobilenav: false,
      faqList: [],
      contactType: "",
      isMobile: false,
    };
  },
  created() {
   
    this.isMobile = isMobile;
    this.consumeDetail = this.$t("mesage.consumeDetail");
    this.content10 = this.$t("mesage.content10");
    // let api_token = getQueryValue("api_token") || localStorage.account_id_token;
    // if (api_token && api_token.length > 30 && (!localStorage.identityToken || localStorage.identityToken && localStorage.identityToken.length <= 30)) {
    //   loginByToken(api_token).then((res) => {
    //     localStorage.account_api_token = localStorage.apiToken = res.data.api_token;
    //     localStorage.account_id_token = localStorage.identityToken = res.data.identity_token;
    //     localStorage.userInfo = res.data.user;
    //   });
    // }

    let faqList = this.$t("mesage.faqs");
    if (faqList) {
      faqList = faqList.replace(/\n/g, "");
      this.faqList = JSON.parse(faqList).list;
    }
  },
  mounted() {
    // this.isLang && this.enQuestionListTitle();
    let mobileMenu = document.getElementById("mobileMenu");
    if (mobileMenu) {
      mobileMenu.addEventListener("click", () => {
        let nav = document.getElementsByClassName("nav");
        if (nav.length) {
          if (nav[0].style.display === "block") {
            nav[0].style.display = "none";
            mobileMenu.classList.remove("active");
          } else {
            nav[0].style.display = "block";
            mobileMenu.classList.add("active");
          }
        }
      });
    }

    let contactBtn = document.getElementsByClassName("contactbtn");
    Array.from(contactBtn).forEach((item) => {
      item.addEventListener("click", () => {
        this.gotoContact();
      });
    });
  },
  computed: {
    ...mapState({
      identityToken: (state) => state.user?.identityToken,
      userInfo: (state) => state.user?.userInfo,
    }),
    activeCreditPrice() {
      let enPrices = this.creditPrices.find(
        (ele) => ele.id === this.creditActiveId
      )?.price;
      return enPrices ? enPrices.split("/")[0] : 0;
    },
    activeMonthlyPrice() {
      let enPrices = this.monthlyPrices.find(
        (ele) => ele.id === this.monthlyActiveId
      )?.price;
      return enPrices ? enPrices.split("/")[0] : 0;
    },
    isLang() {
      return document.documentElement.lang === "zh";
    },
  },
  watch: {
 
  },
  methods: {
    replaceContactLink(str) {
      let link = isMobile
        ? "https://chat-scsp.aliyun.com/index.html?instanceId=MzM1NjY%3D&terminalType=1&preview=1"
        : "https://www.xixifuwuos.com/21221";
      return str.replace(
        "<a class=contactlink>",
        `<a class=contactlink href='${link}'>`
      );
    },
    togglemobienav() {
      this.showmobilenav = !this.showmobilenav;
    },
    enQuestionListTitle() {
      let doms = document.getElementsByClassName("ap-collapse-item__header");
      for (let i = 0; i < 5; i++) {
        doms[i].style.fontSize = "15px";
      }
    },
    freeTry() {
      this.$parent.$parent.mainRoute = "main";
    },
    gotoContact(type) {
      this.contactType = type;
      if (document.documentElement.lang === "zh") {
        // window.open("/contact", "_self");
        this.showWeChat = true;
      } else if (document.documentElement.lang === "en") {
        window.open("/contact", "_self");
      } else if (document.documentElement.lang === "ja") {
        window.open("https://letsview.com/jp/contact", "_self");
      } else if (document.documentElement.lang === "cs") {
        window.open("https://letsview.com/cz/contact", "_self");
      } else if (document.documentElement.lang === "da") {
        window.open("https://letsview.com/dk/contact", "_self");
      } else {
        window.open(
          "https://letsview.com/" + document.documentElement.lang + "/contact",
          "_self"
        );
      }
    },

    contactM() {
      this.payMCall = true;
      this.monthlyActiveId = 6;
    },
    contactC() {
      this.payCCall = true;
      this.creditActiveId = 6;
    },
    setActive(type, price, index) {
      const ACTIVE_ID_TYPE =
        type === "credit" ? "creditActiveId" : "monthlyActiveId";
      this[ACTIVE_ID_TYPE] = price.id;
      if (type == "credit") {
        this.totalC = price.total_price;
        this.payCCall = false; //单选框不选中
        if (
          (index == 5 && !(this.identityToken && this.userInfo)) ||
          (index == 7 && this.identityToken && this.userInfo)
        ) {
          this.creditAll = true;
        }
      } else {
        this.totalM = price.total_price;
        this.payMCall = false;
        if (index == 7) {
          this.monthlyAll = true;
        }
      }
    },
    // 头部相关函数
    showAccountDialog() {
      this.$showModal(
        () => ({
          component: import(
            /* webpackPrefetch: true */
            /*  webpackChunkName: "Account" */
            `@/components/letsView/Account.vue`
          ),
        }),
        {
          width: "500px",
          height: "600px",
        },
        {
          successCallback: () => {
            this.$hideModal("Account");
          },
        },
        "Account"
      );
    },
    buy(activeId, type) {
      if (type == "monthly") {
        this.enPrices = this.monthlyPrices.find((ele) => ele.id === activeId);
        // if (document.documentElement.lang === "es") {
        // this.paddle_id = this.enPrices.espaddle;
        // this.paypal_id = this.enPrices.espaypal;
        // } else {
        this.paddle_id = this.enPrices.paddle;
        // this.paypal_id = this.enPrices.paypal;
        // }
      } else {
        this.enPrices = this.creditPrices.find((ele) => ele.id === activeId);
        // if (document.documentElement.lang === "es") {
        // this.paddle_id = this.enPrices.espaddle;
        // this.paypal_id = this.enPrices.espaypal;
        // } else {
        this.paddle_id = this.enPrices.paddle;
        // this.paypal_id = this.enPrices.paypal;
        // }
      }

      if (
        localStorage.identityToken &&
        localStorage.userInfo &&
        localStorage.identityToken !== "null" &&
        localStorage.userInfo !== "null"
      ) {
        if (LANG !== "zh") {
          this.initOverseaPay();
          // this.enBuy();
        } else {
          this.currentActiveId = activeId;
          this.generateOrder(activeId);
          this.qrcodeDialogVisible = true;
        }
      } else {
        // window.eventBus.$on("model-module:loaded", () => {

        this.showAccountDialog();
        // })
      }
    },
    // 生成订单
    generateOrder(activeId, couponCode) {
      //跟踪参数referer
      if (
        document.documentElement.lang === "zh" &&
        window.location.search.indexOf("apptype") == -1
      ) {
        let f = document.createEvent("Event");
        f.initEvent("wx_update_track", !0, !0), window.dispatchEvent(f);
      }
      window.clearTimeout(this.timeoutInterval);
      this.timeoutInterval = null;
      this.isTimeout = false;
      this.timeoutCount = 1.5 * 60 * 60;
      if (!this.timeoutInterval) {
        this.timeoutInterval = window.setInterval(() => {
          this.timeoutCount--;
          if (this.timeoutCount === 0) {
            this.isTimeout = true;
            window.clearInterval(this.timeoutInterval);
            this.timeoutInterval = null;
            window.clearTimeout(this.queryPayStatusTimeout);
            this.queryPayStatusTimeout = null;
          }
        }, 1000);
      }
      this.isGeneratingOrder = true;
      const products = [
        {
          product_id: activeId,
          quantity: 1,
        },
      ];
      const identityToken = localStorage.identityToken;
      const referer = window.location.href;
      let coupon = couponCode ? couponCode : "";
      generateOrder(coupon, products, identityToken, referer).then((res) => {
        if (res.data.status === 200) {
          this.transaction = res.data.data?.transactions[0];
          this.isGeneratingOrder = false;
          this.getQrcodeUrl();
          this.queryOrderStatus();
          if (couponCode) {
            this.$refs.couponprice.style.display = "inline-block";
          }
        }
      });
    },

    refresh() {
      this.generateOrder(this.currentActiveId);
    },
    couponInputEvent() {
      this.$refs.couponErrorEl.style.display = "none";
    },
    couponSubmit() {
      this.couponLoading = true;
      if (!/^[a-zA-Z0-9]{6,}$/.test(this.$refs.couponInput.value)) {
        this.$refs.couponErrorEl.style.display = "block";
        this.couponLoading = false;
      } else {
        let products = [
          {
            product_id: this.currentActiveId,
            quantity: 1,
          },
        ];
        queryCoupon(this.$refs.couponInput.value, products)
          .then((res) => {
            if (res.data.status === 200) {
              this.$refs.couponErrorEl.style.display = "none";
              this.generateOrder(
                this.currentActiveId,
                this.$refs.couponInput.value
              );
              this.showCoupon = false;
            } else {
              this.$refs.couponErrorEl.style.display = "block";
            }
            this.couponLoading = false;
          })
          .catch((err) => {
            console.log(err);
            this.couponLoading = false;
            this.$refs.couponErrorEl.style.display = "block";
          });
      }
    },
    // 生成二维码
    getQrcodeUrl: async function () {
      const transactionId = this.transaction.transaction_id;
      this.qrCodeUrl = await QRCode.toDataURL(
        // `https://support.apowersoft.cn/api/buy/apowersoft?action=pay&transaction_id=${transactionId}&payment_method=alipay_wxpay_qr&go_pay=1&nocache=1`
        `https://gw.aoscdn.com/base/payment/providers/qrcode/transactions/${transactionId}/ua-jump?payment_account=apowersoft`
      );
    },

    queryOrderStatus: async function () {
      const { data } = await queryOrderStatus(this.transaction.transaction_id);
      if (data && data.status === 200) {
        window.clearTimeout(this.queryPayStatusTimeout);
        this.queryPayStatusTimeout = null;
        if (!data.data || !data.data.transaction) {
          this.queryPayStatusTimeout = window.setTimeout(() => {
            this.queryOrderStatus();
          }, 3000);
        }

        const orderInfo = data.data.transaction;
        const orderStatus = orderInfo.transaction_status;
        if (orderStatus === 0) {
          this.queryPayStatusTimeout = window.setTimeout(() => {
            this.queryOrderStatus();
          }, 1000);
        } else if (orderStatus === 1) {
          this.onOrderPaid();
        }
        // else if (orderStatus === "refund") {
        //   this.$message.error(window.$apTranslations['mesage']['orderRefunded']);
        // } else if (orderStatus === "closed") {
        //   this.$message.error(window.$apTranslations['mesage']['orderClosed']);
        // }
      }
    },

    onOrderPaid() {
      this.$message({
        message: window.$apTranslations["mesage"]["paySuccess"],
        type: "success",
        duration: 2 * 1000,
      });
      this.qrcodeDialogVisible = false;
      window.setTimeout(() => {
        // this.$parent.$parent.mainRoute = "main";
      }, 1000);
    },

    close() {
      window.clearTimeout(this.timeoutInterval);
      this.timeoutInterval = null;
      window.clearTimeout(this.queryPayStatusTimeout);
      this.queryPayStatusTimeout = null;
      this.$refs.couponprice.style.display = "none";
      this.showCoupon = false;
    },

    initOverseaPay() {
      let _this = this;
      !(function (a, b) {
        var c = a.createElement("script");
        (c.src = b), (c.async = !0);
        c.onload = _this.wx_purchase;
        var d = a.getElementsByTagName("script")[0];
        d.parentNode.insertBefore(c, d);
      })(document, "https://cdn.aoscdn.com/js/wx-inline-checkout.js");
    },

    wx_purchase() {
      const lang = document.documentElement.lang;
      // let payPrice = this.enPrices.total_price.slice(1);
      // if (LANG == "de" || LANG == "ja") {
      //   let length = this.enPrices.total_price.length - 1;
      //   payPrice = this.enPrices.total_price.substr(0, length);
      // } else if (LANG == "pt") {
      //   payPrice = this.enPrices.total_price.slice(2);
      // } else if (LANG == "tw") {
      //   payPrice = this.enPrices.total_price.slice(3);
      // }
      // let _this = this;
      var options = {
        hook_click: false,
        // platforms: ["paddle", "paypal"],
        platforms: ["paddle"],
        settings: {
          // paypal: {
          //   currency: "USD",
          //   buttons: ["#js-paypal"],
          //   styles: {
          //     label: "paypal",
          //     shape: "rect",
          //   },
          // },
          paddle: {
            lang,
          },
        },
        callbacks: {
          // get_product: function () {
          //   return {
          //     id: _this.paypal_id,
          //     name: `letsview API (${_this.enPrices.label})`,
          //     price: payPrice, // 截取 $ 后数字  价钱
          //     quantity: "1",
          //   };
          // },
          // "checkout_completed": function (options) {
          // store.buyDialog.options.requestCounts()
          // }
        },
      };
      window.wx_checkout.init(options);
      this.enBuy();
    },

    enBuy() {
      var time = 0;
      var id = setInterval(
        function () {
          time++;
          console.log(time, window.Paddle);
          if (window.Paddle) {
            window.wx_checkout.checkout(
              `https://buy.paddle.com/product/${this.paddle_id}`
            );
            clearInterval(id);
            return;
          }
          if (time > 8) {
            window.wx_checkout.checkout(
              `https://buy.paddle.com/product/${this.paddle_id}`
            );
            clearInterval(id);
          }
        }.bind(this),
        500
      );
    },

    closeChat() {
      this.showWeChat = false;
    },
  },
  filters: {
    couponPrice: function (value) {
      return value.toFixed(2);
    },
  },
};
